import * as React from "react";
const Flag = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M6 5a1 1 0 011-1h11.54a.5.5 0 01.41.787L16.2 8.713a.5.5 0 000 .574l2.75 3.926a.5.5 0 01-.41.787H7v6H6V5zm1 0h10.58l-2.198 3.14a1.5 1.5 0 000 1.72L17.579 13H7V5z" }));
Flag.displayName = "Flag";
var Flag_default = Flag;
export {
  Flag_default as default
};
